import type { IAdminProcess } from '@common/interfaces';
import { ServiceCode } from '@common/enums';
import { ServiceProcessActionsHolter } from './ServiceProcessActionsHolter';

export function ServiceProcessActions(props: Readonly<{ process: IAdminProcess }>) {
    if (props.process.service.code === ServiceCode.Holter) {
        return <ServiceProcessActionsHolter process={props.process} />;
    }

    return null;
}
